import { jsx as _jsx } from "react/jsx-runtime";
export const Icon = ({ faIconName, faSize, className, 'aria-hidden': ariaHidden, }) => {
    const classes = [faIconName, faSize ? `fa-${faSize}` : '', className]
        .filter(Boolean)
        .join(' ');
    return _jsx("i", { className: classes, "aria-hidden": ariaHidden });
};
